import React from 'react';
import { DateTime, SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ExternalUrlGroupsSectionType } from '../metroline/types';
import { ExternalUrlFormIds } from '../constants';
import { ExternalUrlGroupsSection } from '../types';
import { ExternalUrlGroupSequence } from 'app/area/external-url-groups/form/components/external-url-group-sequence';

export const DetailsContainer: React.FC<ExternalUrlGroupsSection> = ({
  externalUrlGroupItem, locale, validation, translation, section, updateItem, getRef, shouldRenderSection
}) => {

  const onDisabledChange = (disabled: Date) => {
    updateItem({ disabled });
  };

  const onExternalUrlSequenceChange = (sequence: number) => {
    updateItem({ sequence });
  };

  const isReadOnly = externalUrlGroupItem?.id === 0;

  return <MetroLineSection<ExternalUrlGroupsSectionType>
    section={section}
    sectionType={ExternalUrlGroupsSectionType.Details}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ExternalUrlGroupsSectionType.Details)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ExternalUrlGroupsSectionType.Details}
        validation={undefined}
        info={{ text: translation.details }}
        label={{ visible: true, text: translation.details }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <ExternalUrlGroupSequence
              value={externalUrlGroupItem?.sequence}
              readOnly={isReadOnly}
              onChange={onExternalUrlSequenceChange}
              locale={locale}
              validation={validation?.[ExternalUrlFormIds.urlTemplate]}
              translation={translation} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <DateTime
              componentId={ExternalUrlFormIds.disabled}
              className="dateTime"
              value={externalUrlGroupItem?.disabled}
              label={translation ? { text: translation.disabled } : undefined}
              readOnly={isReadOnly}
              useTime={false}
              parseDate={parseAsDateUTC}
              createDate={createUTCDate}
              cloneDate={dateToUTC}
              {...createFormatters(locale)}
              locale={locale}
              onChange={onDisabledChange}
              captionWrapper={'form'}
              validation={validation?.[ExternalUrlFormIds.disabled]} />
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
